import React from 'react';

import { FontAwesomeIcon } from '@schoolinks/ui-components';
import { noop } from 'lodash';

import { func } from 'prop-types';

import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';
import Button from 'components/Common/Buttons/ButtonV2';
import DisabledOnMobile from 'components/CommonV2/Icons/DisabledOnMobile';

import MobileBlockedImage from './MobileBlockedImage.png';

import s from './ResponsivePrompt.css';

const ResponsivePrompt = props => {
  const { onCancel } = props;

  return (
    <div className={s.root}>
      <div className={s.header}>
        <DisabledOnMobile /> Locked On Mobile
        <div
          className={s.closeIcon}
          role="button"
          tabIndex={0}
          onClick={onCancel}
        >
          <FontAwesomeIcon icon={faXmark} />
        </div>
      </div>

      <div className={s.promptText}>
        This feature requires a larger screen resolution for optimal viewing
        experience. <br />
        <br />
        Please visit the desktop version of this page!
      </div>
      <div className={s.bottomContainer}>
        <img
          src={MobileBlockedImage}
          alt="Mobile Blocked"
          className={s.image}
        />
        <Button
          variant="outlined"
          onClick={onCancel}
          className={s.singleButton}
        >
          Close
        </Button>
      </div>
    </div>
  );
};

ResponsivePrompt.propTypes = {
  onCancel: func,
};

ResponsivePrompt.defaultProps = {
  onCancel: noop,
};

export default ResponsivePrompt;
